<script>
import { CSAT_RATINGS } from 'shared/constants/messages';
import StarIcon from 'dashboard/components/widgets/conversation/CardCsat/StarIcon.vue';

export default {
  name: 'ReportFiltersRatings',
  emits: ['ratingFilterSelection'],
  components: { StarIcon },
  data() {
    const translatedOptions = CSAT_RATINGS.reverse().map(option => ({
      ...option,
      label: `${this.$t(option.value)} ⭐️`,
    }));
    return {
      selectedOption: null,
      options: translatedOptions,
    };
  },
  methods: {
    handleInput(selectedRating) {
      this.$emit('ratingFilterSelection', selectedRating);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      multiple
      :close-on-select="false"
      :clear-on-select="false"
      hide-selected
      v-model="selectedOption"
      class="no-margin"
      :option-height="24"
      :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
      :options="options"
      :show-labels="false"
      track-by="value"
      label="label"
      @update:model-value="handleInput"
    >
      <!-- 自定义选项模板 -->
      <template #option="{ option }">
        <div class="flex items-center gap-2">
          <span>{{ option.value }}</span>
          <StarIcon color="#ffb623" fill="#ffb623" height="14" width="14" />
        </div>
      </template>
      
      <!-- 自定义选中值模板 -->
      <template #singleLabel="{ option }">
        <div class="flex items-center gap-2">
          <span>{{ option.value }}</span>
          <StarIcon color="#ffb623" fill="#ffb623" height="14" width="14" />
        </div>
      </template>
    </multiselect>
  </div>
</template>
